import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormTab,
  FormTabItem,
  FormTabItemTypeEnum,
} from './interfaces/inspectation-informations.interface';
import {
  FormTabItemsGetTypeEnum,
  FormTabService,
} from '../../../../../management/application-management/form-tab/services/form-tab.service';
import { ParameterService } from '../../../../../../shared/services/parameter/parameter.service';
import { AppMessageService } from '../../../../../../shared/services/app-message/app-message.service';
import { CountryService } from '../../../../../../shared/services/location/country.service';
import { TranslateService } from '@ngx-translate/core';
import { AppAlertService } from '../../../../../../shared/services/app-alert/app-alert.service';
import {
  catchError,
  distinctUntilChanged,
  forkJoin,
  of,
  Subscription,
} from 'rxjs';
import { validateTCKN } from '../../../../../../shared/services/validators/validateTCKN';
import { AbstractControl } from '@angular/forms';
import { CaseDocumentsComponent } from '../tab-header-components/case-documents/case-documents.component';
import { Store } from '@ngrx/store';
import { selectCaseInformations } from '../../../../store/selectors/case-informations.selector';
import {
  selectCaseApproved,
  selectReadonly,
} from '../../../../store/selectors/common-case.selector';

@Component({
  selector: 'app-inspectation-informations',
  templateUrl: './inspectation-informations.component.html',
  styleUrl: './inspectation-informations.component.scss',
})
export class InspectationInformationsComponent implements OnInit, OnDestroy {
  @ViewChild('caseDocument')
  caseDocument: CaseDocumentsComponent;
  formTabs: FormTab[] = [];
  @Input() caseId: number | null = null;
  activeTabIndex = 0;
  caseFormId: number | null;
  caseFormMenuId: number | null;
  loading: boolean = false;
  countries: string[] = [];
  showAnswered: boolean = false;
  commonTabs: any[] = [
    {
      title: 'case.inspectation-informations.diagnoses',
      description: '',
    },
    {
      title: 'case.inspectation-informations.vital-signs',
      description: '',
    },

    {
      title: 'case.inspectation-informations.photos',
      description: '',
    },
  ];
  clickedCommonTabIndex: number | null = null;
  selectedCommonTab: any = null;
  private readonly subscriptions = new Subscription();
  diagnoses: any[] = [];
  vitalSigns: any[] = [];
  canSendForm: boolean = false;
  searchText: string = '';
  isCaseApproved: boolean = false;
  isReadOnly: boolean = false;
  constructor(
    private readonly formTabService: FormTabService,
    private readonly parameterService: ParameterService,
    private readonly messageService: AppMessageService,
    private readonly countrieService: CountryService,
    private readonly translate: TranslateService,
    private readonly alertService: AppAlertService,
    private readonly store: Store
  ) {}

  get activeTab(): FormTab | null {
    if (this.activeTabIndex === -1) {
      return null;
    }
    return this.formTabs[this.activeTabIndex] || null;
  }

  ngOnInit() {
    this.loading = true;
    forkJoin({
      formId: this.parameterService
        .getParameterValueByKeyname('case-form-id')
        .pipe(catchError(() => of(null))),
      formMenuId: this.parameterService
        .getParameterValueByKeyname('case-form-menu-id')
        .pipe(catchError(() => of(null))),
      countries: this.countrieService.getAll().pipe(catchError(() => of([]))),
    }).subscribe({
      next: ({ formId, formMenuId, countries }) => {
        this.caseFormId =!formId?.value || Number.isNaN(Number(formId?.value))
          ? null
          : Number(formId?.value);
        this.caseFormMenuId =!formMenuId?.value || Number.isNaN(Number(formMenuId?.value))
          ? null
          : Number(formMenuId?.value);
        this.countries = (countries ?? [])
          .filter((c: any) => c?.name)
          .map((e: any) => e.name);
        if (this.caseFormId && this.caseFormMenuId && this.caseId) {
          this.formTabService
            .getAllTabItemsByFormIdAndFormMenuId({
              caseId: this.caseId,
              formId: this.caseFormId,
              formMenuId: this.caseFormMenuId,
              type: FormTabItemsGetTypeEnum.QUESTION_ANSWER,
            })
            .subscribe({
              next: (res) => {
                this.formTabs = this.sortFormTabs(res.map(this.mapFormTab.bind(this))) ?? [];
                this.loading = false;
                this.setTabsCompleted();
              },
              error: () => {
                this.loading = false;
              },
            });
        } else {
          this.loading = false;
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Parametreler alınırken hata oluştu:', err);
      },
    });

    this.subscriptions.add(
      this.store
        .select(selectCaseInformations)
        .pipe(distinctUntilChanged())
        .subscribe((caseInformations) => {
          this.diagnoses = caseInformations?.diagnoses ?? [];
          this.vitalSigns = caseInformations?.vitalSigns ?? [];
        })
    );

    this.subscriptions.add(
      this.store
        .select(selectReadonly)
        .pipe(distinctUntilChanged())
        .subscribe((isReadOnly) => {
          this.isReadOnly = isReadOnly ?? false;
        })
    );

    this.subscriptions.add(
      this.store
        .select(selectCaseApproved)
        .pipe(distinctUntilChanged())
        .subscribe((isApproved) => {
          this.isCaseApproved = isApproved ?? false;
        })
    );
  }


  private mapAndSortFormTabItems(items: FormTabItem[]): FormTabItem[] {
  if (!items) return [];

  return [...items]
    .map(item => {
      if (item.type === FormTabItemTypeEnum.COUNTRY) {
        item.typeData = this.countries;
      }
      return item;
    })
    .sort((a, b) => (a?.sort ?? Infinity) - (b?.sort ?? Infinity));
}

private mapFormTab(e: FormTab): FormTab {
  const formTabItems = this.mapAndSortFormTabItems(e.formTabItems);
  return {
    ...e,
    isTabCompleted: null,
    formTabItems,
    filteredFormTabItems: formTabItems,
  };
}

private sortFormTabs(tabs: FormTab[]): FormTab[] {
  return [...tabs].sort((a, b) => (a?.sort ?? Infinity) - (b?.sort ?? Infinity));
}
  setActiveTab(index: number) {
    if (this.selectedCommonTab) {
      this.activeTabIndex = 0;
      this.clickedCommonTabIndex = null;
      this.selectedCommonTab = null;
      return;
    }
    if (
      index > this.activeTabIndex &&
      !this.formTabs[this.activeTabIndex]?.isTabCompleted
    ) {
      this.messageService.warningToast(
        this.translate.instant(
          'case.inspectation-informations.validation-title'
        ),
        this.translate.instant(
          'case.inspectation-informations.validation-description'
        )
      );
      return;
    }
    this.activeTabIndex = index;
  }

  nextTab() {
    if (!this.formTabs[this.activeTabIndex]?.isTabCompleted) {
      this.messageService.warningToast(
        this.translate.instant(
          'case.inspectation-informations.validation-title'
        ),
        this.translate.instant(
          'case.inspectation-informations.validation-description'
        )
      );
      return;
    }
    if (this.activeTabIndex < this.formTabs.length - 1) {
      this.activeTabIndex++;
    }
    this.clickedCommonTabIndex = null;
    this.selectedCommonTab = null;
  }

  previousTab() {
    if (this.activeTabIndex > 0) {
      this.activeTabIndex--;
    }
  }

  onAnswerChange(tabId: number, itemId: number, answer: any) {
    const index = this.formTabs.findIndex((i) => i.id === tabId);
    if (index > -1) {
      this.setTabCompleted(index);
    }
  }

  setTabCompleted(tabIndex: number) {
    const tab = this.formTabs[tabIndex];
    if (tab) {
      const mandatoryItems = tab.filteredFormTabItems.filter(
        (item) => item.isMandatory
      );
      const cond1 = mandatoryItems.every((item) => {
        const answer = item.answerValue;
        return answer !== null && answer !== '' && answer !== undefined;
      });
      const cond2 = tab.filteredFormTabItems.find(
        (i) => i?.answerValue?.includes('_aciklama') && !i?.description
      );
      tab.isTabCompleted = cond1 && !cond2;
    }
    this.checkCanSendForm();
  }

  setTabsCompleted() {
    for (const tab of this.formTabs) {
      const mandatoryItems = tab.filteredFormTabItems.filter(
        (item) => item.isMandatory
      );

      const cond1 = mandatoryItems.every(item => {
        const answer = item.answerValue;
        return answer !== null && answer !== '' && answer !== undefined;
      });

      const cond2 = tab.filteredFormTabItems.find(
        (i) => i?.answerValue?.includes('_aciklama') && !i?.description
      );

      tab.isTabCompleted = cond1 && !cond2;
    }

    this.checkCanSendForm();
  }

  checkCanSendForm() {
    const hasError = this.formTabs.find((e) => !e.isTabCompleted);
    if (hasError) {
      this.canSendForm = false;
      return false;
    }

    let canSend = true;

    for (const tab of this.formTabs) {
      // Açıklama hatası olan item var mı kontrol et
      const hasErr = tab?.filteredFormTabItems?.some(
        (i) =>
          i?.type !== FormTabItemTypeEnum.DATE &&
          i?.answerValue?.includes('_aciklama') &&
          !i?.description
      );

      if (hasErr) {
        canSend = false;
        break;
      }

      // TCKN doğrulaması
      const idNumber = tab.filteredFormTabItems?.find(
        (t) => t.type === FormTabItemTypeEnum.ID_NUMBER
      )?.answerValue;

      if (idNumber) {
        const result = validateTCKN({ value: idNumber } as AbstractControl);
        if (result) {
          canSend = false;
          break;
        }
      }
    }

    this.canSendForm = canSend;
    return true;
  }

  sendSubmit() {
    this.alertService.sweetConfirm({
      header: this.translate.instant(
        'case.inspectation-informations.are-you-sure-header'
      ),
      message: this.translate.instant(
        'case.inspectation-informations.are-you-sure-text'
      ),
      showCloseButton: true, 
      accept: () => {
        this.submitForm();
      },
    });
  }
  submitForm() {
    const hasError = this.formTabs.find((e) => !e.isTabCompleted);
    if (hasError) {
      this.messageService.warningToast(
        this.translate.instant(
          'case.inspectation-informations.validation-title'
        ),
        this.translate.instant(
          'case.inspectation-informations.validation-description'
        )
      );
      return;
    }

    let invalid = false;
    let tcknInvalid = false;

    for (const tab of this.formTabs) {
      const hasErr = tab?.filteredFormTabItems?.some(
        (i) =>
          i?.type !== FormTabItemTypeEnum.DATE &&
          i?.answerValue?.includes('_aciklama') &&
          !i?.description
      ) ?? false;

      const idNumber = tab.filteredFormTabItems?.find(
        (t) => t.type === FormTabItemTypeEnum.ID_NUMBER
      )?.answerValue;

      if (idNumber && validateTCKN({ value: idNumber } as AbstractControl)) {
        tcknInvalid = true;
        break;
      }

      if (hasErr) {
        invalid = true;
        break;
      }
    }

    // Uyarıları tek yerde göster
    if (tcknInvalid) {
      this.messageService.warningToast(
        '',
        this.translate.instant('case.inspectation-informations.invalid-tckn')
      );
    } else if (invalid) {
      this.messageService.warningToast(
        this.translate.instant('case.inspectation-informations.validation-title'),
        this.translate.instant('case.inspectation-informations.validation-description')
      );
    }


    const allAnswers = this.formTabs.flatMap((tab) =>
      tab?.filteredFormTabItems?.map((item: any) => ({
        formId: this.caseFormId!,
        formMenuId: this.caseFormMenuId!,
        formTabId: tab?.id,
        formTabItemId: item?.id!,
        description: item?.description,
        caseId: this.caseId!,
        answerLabel: item?.title,
        answerValue:
          item?.type === FormTabItemTypeEnum.MULTISELECT
            ? this.changeMultiSelect(item?.answerValue)
            : item?.answerValue,
      }))
    );

    this.formTabService.saveQuestions(allAnswers).subscribe({
      next: (res) => {
        if (res.success) {
          this.messageService.successToast(
            this.translate.instant('common.success'),
            this.translate.instant(
              'case.inspectation-informations.success-save'
            )
          );
        }
      },
      error: () => {},
    });
  }

  filterArray() {
    const search = (this.searchText || '').toLowerCase();
    for(const tab of this.formTabs){
      tab.filteredFormTabItems = tab.formTabItems ?? [];

      if (this.showAnswered) {
        tab.filteredFormTabItems = tab.filteredFormTabItems.filter((a) => {
          if (Array.isArray(a?.answerValue)) {
            return a.answerValue.length > 0;
          } else {
            return a?.answerValue != null && a?.answerValue !== '';
          }
        });
      }
      if (search) {
        tab.filteredFormTabItems = tab.filteredFormTabItems.filter((a) =>
          a?.title?.toLowerCase?.().includes(search)
        );
      }
    }
  }
  private changeMultiSelect(answer: any[] | null) {
    if (!answer || answer?.length === 0) {
      return null;
    }
    return `{"${answer.join('","')}"}`;
  }

  commonTabClick(index: number) {
    this.clickedCommonTabIndex = index;
    this.selectedCommonTab = this.commonTabs[index];
    if (index === 2) {
      this.caseDocument.initilize(this.caseId, 'ambulance', 'readonly');
    }
  }

  onDocumentClose() {
    this.clickedCommonTabIndex = null;
    this.selectedCommonTab = null;
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    this.unSub();
  }

  unSub() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
  ngOnDestroy(): void {
    this.unSub();
  }
}
